import SmsSubscriptionClient from "@onnit-js/ui/services/SmsSubscriptionClient";
import OrderCreatedEvent from "../events/OrderCreatedEvent";
import config from "../../config";

export const subscribe = ({ cart }: OrderCreatedEvent) => {
    const phone = cart.shipping_address?.phone;
    const client = new SmsSubscriptionClient();

    if (!cart.preferences.do_opt_in_sms || !phone) {
        return;
    }

    if (cart.preferences.do_opt_in_sms && !phone) {
        console.error("Phone unexpectedly undefined for sms opt in.");
        return;
    }

    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.subscribe({
        phone,
        cookies: document.cookie,
        creativeId: config.ATTENTIVE_CREATIVE_ID,
    });
};

export default subscribe;
